(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noy-cushion"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('noy-cushion')) {
  customElements.define('noy-cushion', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('change', event => {
        if (!event.target.matches('input[name="id"]')) return;
        this.selectVariant(event.target);
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-quantity]');
        if (!button) return;
        const input = this.querySelector('[name="quantity"]');
        button.dataset.quantity === 'up' ? input.stepUp() : input.stepDown();
      });
      window.addEventListener('popstate', () => {
        const id = new URL(window.location.href).searchParams.get('variant');
        const input = [...this.querySelectorAll('[name="id"]')].find(el => el.value === id) || this.querySelector('[name="id"]');
        if (input) { input.checked = true; this.selectVariant(input, false); }
      });
    }
    selectVariant(input, updateUrl = true) {
      this.querySelector('[data-selection]').textContent = input.dataset.title;
      this.querySelector('[data-price]').textContent = input.dataset.price;
      const image = this.querySelector('.noy-cushion__image');
      if (input.dataset.image) { image.removeAttribute('srcset'); image.src = input.dataset.image; image.alt = input.dataset.alt || input.dataset.title; }
      const submit = this.querySelector('[name="add"]');
      submit.disabled = input.dataset.available !== 'true';
      submit.textContent = submit.disabled ? submit.dataset.sold : submit.dataset.add;
      if (updateUrl) { const url = new URL(window.location.href); url.searchParams.set('variant', input.value); window.history.replaceState({}, '', url); }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noy-fabrics"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.noyReady)return;root.dataset.noyReady='1';
    var stage=root.querySelector('[data-noy-stage]'),base=root.querySelector('[data-noy-base]'),top=root.querySelector('[data-noy-top]'),loupe=root.querySelector('[data-noy-loupe]'),tag=root.querySelector('[data-noy-tag]');
    var sws=[].slice.call(root.querySelectorAll('[data-noy-sw]')),names=[].slice.call(root.querySelectorAll('[data-noy-name]'));
    if(!sws.length)return;
    var srcs=sws.map(function(b){return b.dataset.src;});
    var cur=0,busy=false,queued=null,ZOOM=2.4;
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var warmed=false;
    function warm(){if(warmed)return;warmed=true;srcs.forEach(function(s){var i=new Image();i.src=s;});}
    if('IntersectionObserver' in window){var io=new IntersectionObserver(function(es){if(es[0].isIntersecting){warm();io.disconnect();}},{rootMargin:'600px'});io.observe(root);}else{warm();}
    loupe.style.backgroundImage='url("'+srcs[0]+'")';
    function pick(k){
      if(k===cur)return;
      if(busy){queued=k;return;}
      busy=true;warm();
      sws.forEach(function(b,j){b.setAttribute('aria-checked',String(j===k));});
      names.forEach(function(d,j){d.classList.toggle('is-on',j===k);});
      tag.textContent=sws[k].dataset.name;
      top.style.backgroundImage='url("'+srcs[k]+'")';
      loupe.style.backgroundImage='url("'+srcs[k]+'")';
      function done(){
        base.style.backgroundImage='url("'+srcs[k]+'")';
        base.classList.remove('is-push');top.classList.remove('is-go');
        cur=k;busy=false;
        if(queued!==null){var q=queued;queued=null;pick(q);}
      }
      if(reduce){done();return;}
      void top.offsetWidth;
      top.classList.add('is-go');base.classList.add('is-push');
      setTimeout(done,1300);
    }
    sws.forEach(function(b,j){b.addEventListener('click',function(){pick(j);});});
    root.querySelector('.noy-fab__swatches').addEventListener('keydown',function(e){
      var d=e.key==='ArrowLeft'?1:e.key==='ArrowRight'?-1:0;if(!d)return;
      var at=sws.indexOf(document.activeElement);if(at<0)return;
      var k=(at+d+sws.length)%sws.length;sws[k].focus();pick(k);
    });
    function move(e){
      var r=stage.getBoundingClientRect(),x=e.clientX-r.left,y=e.clientY-r.top,lw=loupe.offsetWidth;
      loupe.style.left=x+'px';loupe.style.top=y+'px';
      loupe.style.backgroundSize=(r.width*ZOOM)+'px '+(r.height*ZOOM)+'px';
      loupe.style.backgroundPosition=(-(x*ZOOM-lw/2))+'px '+(-(y*ZOOM-lw/2))+'px';
    }
    if(window.matchMedia('(hover:hover)').matches){
      stage.addEventListener('pointerenter',function(e){stage.classList.add('is-live');move(e);});
      stage.addEventListener('pointermove',move);
      stage.addEventListener('pointerleave',function(){stage.classList.remove('is-live');});
    }
  }
  function boot(){[].forEach.call(document.querySelectorAll('[data-noy-fab]'),init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noy-home-projects"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.noyReady)return;root.dataset.noyReady='1';
    var vp=root.querySelector('[data-noy-viewport]'),track=root.querySelector('[data-noy-track]');
    var slides=[].slice.call(root.querySelectorAll('[data-noy-slide]')),infos=[].slice.call(root.querySelectorAll('[data-noy-info]'));
    var bars=[].slice.call(root.querySelectorAll('[data-noy-bars] button')),cur=root.querySelector('[data-noy-cur]');
    var n=slides.length,i=0;if(!n)return;
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* right-to-left: the track moves right to bring the next slide in; left-to-right: it moves left */
    var sgn=getComputedStyle(root).direction==='rtl'?1:-1;
    function step(){var g=parseFloat(getComputedStyle(track).columnGap)||0;return slides[0].offsetWidth+g;}
    function place(extra){track.style.transform='translateX('+(sgn*i*step()+(extra||0))+'px)';}
    function go(k){
      i=(k+n)%n;
      slides.forEach(function(s,j){s.classList.toggle('is-active',j===i);s.classList.toggle('is-before',j<i);});
      infos.forEach(function(a,j){a.classList.toggle('is-on',j===i);});
      bars.forEach(function(b,j){b.classList.remove('is-on');b.classList.toggle('is-done',j<i);});
      if(bars[i]){void bars[i].offsetWidth;bars[i].classList.add('is-on');}
      cur.textContent=('0'+(i+1)).slice(-2);
      place();
    }
    bars.forEach(function(b,j){
      b.addEventListener('click',function(){go(j);});
      b.addEventListener('animationend',function(){if(!reduce&&j===i)go(i+1);});
    });
    root.querySelector('[data-noy-next]').addEventListener('click',function(){go(i+1);});
    root.querySelector('[data-noy-prev]').addEventListener('click',function(){go(i-1);});
    var nextKey=sgn>0?'ArrowLeft':'ArrowRight',prevKey=sgn>0?'ArrowRight':'ArrowLeft';
    root.addEventListener('keydown',function(e){if(e.key===nextKey)go(i+1);else if(e.key===prevKey)go(i-1);});
    var sx=0,dx=0,down=false,moved=false;
    vp.addEventListener('pointerdown',function(e){down=true;moved=false;sx=e.clientX;dx=0;});
    vp.addEventListener('pointermove',function(e){if(!down)return;dx=e.clientX-sx;if(Math.abs(dx)>6){moved=true;vp.classList.add('is-dragging');place(dx*.9);}});
    function up(){if(!down)return;down=false;vp.classList.remove('is-dragging');var d=dx*sgn;if(d>60)go(i+1);else if(d<-60)go(i-1);else place();}
    vp.addEventListener('pointerup',up);vp.addEventListener('pointercancel',up);vp.addEventListener('pointerleave',up);
    /* a click on the active image opens its project; a click on a peeking one brings it forward; a drag does neither */
    slides.forEach(function(s,j){s.addEventListener('click',function(){if(!moved&&j!==i)go(j);});});
    [].forEach.call(root.querySelectorAll('[data-noy-open]'),function(a){
      a.addEventListener('click',function(e){if(moved)e.preventDefault();});
      a.addEventListener('dragstart',function(e){e.preventDefault();});
    });
    window.addEventListener('resize',function(){place();});
    go(0);
  }
  function boot(){[].forEach.call(document.querySelectorAll('[data-noy-hp]'),init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noy-journey-skip"] && !Shopify.designMode) return;
  try {
    
(function(){
  function findScroller(el){
    var e=el.parentElement;
    while(e&&e!==document.body&&e!==document.documentElement){
      var oy=getComputedStyle(e).overflowY;
      if((oy==='auto'||oy==='scroll')&&e.scrollHeight>e.clientHeight+4)return e;
      e=e.parentElement;
    }
    return null;
  }
  function init(){
    var cfg=document.querySelector('[data-noy-journey-skip]');
    var journey=document.querySelector('.journey');
    if(!cfg||!journey||journey.dataset.noySkip)return;
    var sticky=journey.querySelector('.journey__sticky');if(!sticky)return;
    journey.dataset.noySkip='1';
    var full=(parseFloat(cfg.dataset.seconds)||6)*1000;
    var labelDown=cfg.dataset.label||'Skip',labelUp=cfg.dataset.labelBack||labelDown;
    var btn=document.createElement('button');
    btn.type='button';btn.className='noy-skip is-off';
    btn.innerHTML='<span></span><svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M2 3l5 4 5-4M2 8l5 4 5-4"/></svg>';
    var text=btn.firstChild;text.textContent=labelDown;
    sticky.appendChild(btn);
    var raf=0,box=null,dir=1,lastY=null;
    function scroller(){if(!box||!box.isConnected)box=findScroller(journey);return box;}
    function getY(){var s=scroller();return s?s.scrollTop:window.scrollY;}
    function setY(y){var s=scroller();if(s){s.scrollTop=y;}else{window.scrollTo(0,y);}}
    function viewH(){var s=scroller();return s?s.clientHeight:window.innerHeight;}
    function range(){
      var s=scroller(),top=journey.getBoundingClientRect().top+getY()-(s?s.getBoundingClientRect().top:0);
      return {start:top,end:top+journey.offsetHeight-viewH()};
    }
    function setDir(d){
      if(d===dir)return;dir=d;
      btn.classList.toggle('is-up',dir<0);
      text.textContent=dir<0?labelUp:labelDown;
    }
    function update(){
      var r=range(),y=getY(),span=Math.max(1,r.end-r.start),p=(y-r.start)/span;
      /* the direction follows the visitor's own scrolling, not the glide the button itself runs */
      if(!raf&&lastY!==null&&Math.abs(y-lastY)>2)setDir(y<lastY?-1:1);
      lastY=y;
      /* at either end only one direction makes sense */
      if(!raf){if(p>=0.86)setDir(-1);else if(p<=0.14)setDir(1);}
      btn.classList.toggle('is-off',!(p>-0.02&&p<1.02));
    }
    function stop(){if(raf){cancelAnimationFrame(raf);raf=0;}}
    function go(){
      stop();
      var r=range(),from=getY(),to=dir<0?r.start:r.end-2,dist=to-from;if(Math.abs(dist)<4)return;
      if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){setY(to);return;}
      /* continuous glide: the whole journey takes the set number of seconds, a part of it takes its share (never under 2s) */
      var dur=Math.max(2000,full*Math.abs(dist)/Math.max(1,r.end-r.start)),t0=performance.now();
      var target=scroller()||document.documentElement,prev=target.style.scrollBehavior;target.style.scrollBehavior='auto';
      function ease(t){return t<.5?2*t*t:1-Math.pow(-2*t+2,2)/2;}
      function tick(now){
        var t=Math.min(1,(now-t0)/dur);
        setY(from+dist*ease(t));
        if(t<1){raf=requestAnimationFrame(tick);}else{raf=0;target.style.scrollBehavior=prev;lastY=getY();update();}
      }
      raf=requestAnimationFrame(tick);
    }
    btn.addEventListener('click',go);
    ['wheel','touchstart','keydown','mousedown'].forEach(function(ev){window.addEventListener(ev,function(e){if(raf&&e.target!==btn&&!btn.contains(e.target))stop();},{passive:true});});
    window.addEventListener('scroll',update,{passive:true,capture:true});
    window.addEventListener('resize',update);
    update();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noy-project"]) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.noyReady)return;root.dataset.noyReady='1';
    var tiles=[].slice.call(root.querySelectorAll('[data-noy-tile]'));
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(!reduce&&'IntersectionObserver' in window){
      var below=tiles.filter(function(t){return t.getBoundingClientRect().top>window.innerHeight*.95;});
      if(below.length){
        var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.remove('is-wait');e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.1});
        below.forEach(function(t){t.classList.add('is-wait');io.observe(t);});
      }
    }
    if(reduce){[].forEach.call(root.querySelectorAll('.noy-project__tile video'),function(v){v.removeAttribute('autoplay');v.pause();});}
    var lb=root.querySelector('[data-noy-lb]'),stage=root.querySelector('[data-noy-stage]'),count=root.querySelector('[data-noy-count]'),k=0,last=null;
    if(!lb)return;
    function show(i){
      k=(i+tiles.length)%tiles.length;var t=tiles[k],el;
      if(t.dataset.video){el=document.createElement('video');el.src=t.dataset.video;el.controls=true;el.autoplay=true;el.loop=true;el.muted=true;el.playsInline=true;}
      else{el=document.createElement('img');el.src=t.dataset.image;el.alt=t.dataset.alt||'';}
      stage.textContent='';stage.appendChild(el);
      count.textContent=(k+1)+' / '+tiles.length;
    }
    function open(i){last=document.activeElement;lb.hidden=false;document.documentElement.style.overflow='hidden';show(i);root.querySelector('[data-noy-close]').focus();}
    function close(){lb.hidden=true;stage.textContent='';document.documentElement.style.overflow='';if(last)last.focus();}
    tiles.forEach(function(t,i){t.addEventListener('click',function(){open(i);});});
    root.querySelector('[data-noy-close]').addEventListener('click',close);
    root.querySelector('[data-noy-next]').addEventListener('click',function(){show(k+1);});
    root.querySelector('[data-noy-prev]').addEventListener('click',function(){show(k-1);});
    lb.addEventListener('click',function(e){if(e.target===lb||e.target===stage)close();});
    document.addEventListener('keydown',function(e){
      if(lb.hidden)return;
      if(e.key==='Escape')close();else if(e.key==='ArrowLeft')show(k+1);else if(e.key==='ArrowRight')show(k-1);
    });
  }
  function boot(){[].forEach.call(document.querySelectorAll('.noy-project'),init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noy-projects-lobby"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.noyReady)return;root.dataset.noyReady='1';
    var wall=root.querySelector('[data-noy-wall]'),chipsBox=root.querySelector('[data-noy-chips]'),count=root.querySelector('[data-noy-count]');
    var cards=[].slice.call(wall.children);
    cards.sort(function(a,b){return (parseFloat(a.dataset.order)||9999)-(parseFloat(b.dataset.order)||9999);});
    cards.forEach(function(c){wall.appendChild(c);});
    var types=[];cards.forEach(function(c){if(c.dataset.t&&types.indexOf(c.dataset.t)<0)types.push(c.dataset.t);});
    types.forEach(function(t){var b=document.createElement('button');b.type='button';b.dataset.f=t;b.setAttribute('aria-pressed','false');b.textContent=t;chipsBox.appendChild(b);});
    var chips=[].slice.call(chipsBox.children);
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function spansFor(n){
      /* rows alternate 7/5 and 5/7, with a full-width card after every two rows; never two full-width cards in a row, never a card alone in half a row */
      var out=[],i=0,flip=false,rows=0;
      while(i<n){
        var left=n-i;
        if(left===1){out.push(12);i+=1;break;}
        if(rows===2&&left!==2){out.push(12);i+=1;rows=0;continue;}
        if(flip){out.push(5,7);}else{out.push(7,5);}
        flip=!flip;i+=2;rows+=1;
      }
      return out;
    }
    function layout(f){
      var vis=cards.filter(function(c){var on=f==='all'||c.dataset.t===f;c.hidden=!on;return on;});
      var spans=spansFor(vis.length);
      vis.forEach(function(c,i){c.style.gridColumn='span '+spans[i];});
      count.textContent=vis.length===1?root.dataset.one:vis.length+' '+root.dataset.many;
    }
    function apply(f){
      chips.forEach(function(b){b.setAttribute('aria-pressed',String(b.dataset.f===f));});
      if(reduce){layout(f);return;}
      wall.classList.add('is-swap');
      setTimeout(function(){cards.forEach(function(c){c.classList.remove('is-wait','is-in');});layout(f);wall.classList.remove('is-swap');},280);
    }
    chips.forEach(function(b){b.addEventListener('click',function(){apply(b.dataset.f);});});
    layout('all');
    if(!reduce&&'IntersectionObserver' in window){
      var below=cards.filter(function(c){return c.getBoundingClientRect().top>window.innerHeight*.95;});
      if(below.length){
        var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.remove('is-wait');e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.1});
        below.forEach(function(c){c.classList.add('is-wait');io.observe(c);});
      }
    }
  }
  function boot(){[].forEach.call(document.querySelectorAll('[data-noy-lobby]'),init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noy-shared-styles"]) return;
  try {
    
(function(){
  function run(){
    var els=[].slice.call(document.querySelectorAll('[data-noy-rv]:not([data-noy-rv-done])'));
    if(!els.length)return;
    els.forEach(function(e){e.setAttribute('data-noy-rv-done','');});
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver' in window))return;
    var below=els.filter(function(e){return e.getBoundingClientRect().top>window.innerHeight*.95;});
    if(!below.length)return;
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.remove('is-wait');io.unobserve(e.target);}});},{threshold:.12});
    below.forEach(function(e){e.classList.add('is-wait');io.observe(e);});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  document.addEventListener('shopify:section:load',run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noy-voices"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.noyReady)return;root.dataset.noyReady='1';
    var qs=[].slice.call(root.querySelectorAll('[data-noy-quote]')),ps=[].slice.call(root.querySelectorAll('[data-noy-vimg]')),count=root.querySelector('[data-noy-count]');
    var k=0,timer=0,secs=(parseFloat(root.dataset.seconds)||7)*1000;
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function pad(n){return n<10?'0'+n:''+n;}
    function show(i){
      k=(i+qs.length)%qs.length;
      qs.forEach(function(q,j){q.classList.toggle('is-on',j===k);});
      /* a quote without its own photo keeps the photo that is already showing */
      var next=ps.filter(function(p){return +p.dataset.noyVimg===k;})[0];
      if(next&&!next.classList.contains('is-on')){
        ps.forEach(function(p){p.classList.toggle('is-prev',p.classList.contains('is-on'));p.classList.remove('is-on');});
        void next.offsetWidth;next.classList.remove('is-prev');next.classList.add('is-on');
      }
      if(count)count.textContent=pad(k+1)+' / '+pad(qs.length);
    }
    function auto(){clearInterval(timer);if(!reduce&&qs.length>1)timer=setInterval(function(){show(k+1);},secs);}
    var n=root.querySelector('[data-noy-next]'),p=root.querySelector('[data-noy-prev]');
    if(n)n.addEventListener('click',function(){show(k+1);auto();});
    if(p)p.addEventListener('click',function(){show(k-1);auto();});
    root.addEventListener('mouseenter',function(){clearInterval(timer);});
    root.addEventListener('mouseleave',auto);
    if(ps.length)ps[0].classList.add('is-on');
    show(0);auto();
  }
  function boot(){[].forEach.call(document.querySelectorAll('[data-noy-voices]'),init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();
})();
